export function chapterNumber(chapterId: string): number | null {
  const match = /^ch(\d+)$/.exec(chapterId);
  if (match === null) {
    return null;
  }
  return Number(match[1]);
}

export function formatChapterId(number: number): string {
  return `ch${String(number).padStart(2, "0")}`;
}

/** `/hp/2` and `/hp/ch02` both mean chapter 2. */
export function parseChapterRoute(raw: string | undefined): string {
  if (raw === undefined || raw.length === 0) {
    return "ch01";
  }
  if (/^\d+$/.test(raw)) {
    return formatChapterId(Number(raw));
  }
  const number = chapterNumber(raw);
  if (number === null || number < 1) {
    return "ch01";
  }
  return formatChapterId(number);
}

/** A book that only numbers its chapters stores "Chapter 5", so the number is not said twice. */
export function formatChapterHeading(chapterId: string, title: string, separator = " · "): string {
  const number = chapterNumber(chapterId);
  if (number === null) {
    return title;
  }
  // A film has parts, not chapters, and they need no number in front of them.
  return title === `Chapter ${number}` || /^Part \d+$/.test(title)
    ? title
    : `Chapter ${number}${separator}${title}`;
}
